(function () {
  document.querySelectorAll('[data-gorgias-help-center-root]').forEach((root) => {
    if (root.dataset.gorgiasHelpCenterInitialized === 'true') return;
    root.dataset.gorgiasHelpCenterInitialized = 'true';

    const loader = root.querySelector('.gorgias-help-center__loading');
    const fallback = root.querySelector('[data-gorgias-help-center-fallback]');
    let ready = false;
    let timeoutId;

    const observer = new MutationObserver(() => {
      const iframe = root.querySelector(
        'section[data-gorgias-help-center-uid] > iframe[title="Gorgias Help Center"]',
      );
      const directContent = root.querySelector('.ghc-main-wrapper');
      const iframeHasHeight = iframe && /^\d+(\.\d+)?px$/.test(iframe.style.height);

      if (!directContent && !iframeHasHeight) return;

      ready = true;
      window.clearTimeout(timeoutId);
      loader.hidden = true;
      root.classList.add('is-ready');
      observer.disconnect();
    });

    observer.observe(root, { attributes: true, childList: true, subtree: true });

    timeoutId = window.setTimeout(() => {
      loader.hidden = true;
      observer.disconnect();

      if (!ready) {
        root.classList.add('has-timed-out');
        fallback.hidden = false;
      }
    }, 12000);
  });
})();
